import React, { useEffect, useState } from 'react';
import { Input } from 'antd';
import _ from 'lodash';

const InputWithPlaceholder = React.forwardRef((props, ref) => {
    const [text, setText] = useState('');
    const _props = {
        ...props
    };

    useEffect(() => {
        setText(props.value);
    }, [props.value]);
    _props.placeholder && delete _props.placeholder;
    return <div style={{ ...props.style, position: 'relative' }}>
        <Input ref={ref} {..._.omit(_props, "propsGenerator", "listField")} style={{ ...props.style, width: '100%' }} onChange={(e) => {
            props.onChange && props.onChange(e);
            setText(e.currentTarget.value);
        }} />
        {(!text && text !== 0) && <div className='input-placeholder d-flex align-items-center' style={{ ...props.style, width: '100%'}}>{props.placeholder}</div>}
    </div>
});

export default InputWithPlaceholder;